export enum Company {
  Zito = 'Žito',
  Dobro = 'Dobro'
}

export const CompanyOptions = [
  { value: Company.Zito, label: Company.Zito },
  { value: Company.Dobro, label: Company.Dobro }
];
